import Helper from "./Helper.js";
import HttpClient from "./HttpClient.js";
import Client from "./HttpClient.js";
export default class Export {
  constructor(pallets, trucks, client) {
    this.pallets = this.getPrintingPallets(pallets);
    this.trucks = trucks;
    this.httpClient = client;
  }

  getPrintingPallets(pallets) {
    return pallets.filter(e => {
      return !e.temporary;
    });
  }

  async palletsPreparationExport() {
    const pdf = await this.httpClient.instance.post("pallets/pdf/preperation", {
      pallets: Helper.getIdsString(this.pallets)
    });
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  async opticutFileExport(vue) {
    let pallets = [];
    this.pallets.forEach(pallet => {
      if (pallet.status >= 1) {
        pallets.push(pallet);
      }
    });
    if (this.pallets.length != pallets.length) {
      alert(vue.$t('exports.warning'));
    }
    const opticutResponse = await this.httpClient.instance.post(
      "pallet-structures/export",
      { pallets: Helper.getIdsString(pallets) }
    );
    await Helper.timeout(50);
    const opticut = opticutResponse.data;
    this.download(opticut.name, opticut.content);
  }

  async truckExport() {
    const pdf = await this.httpClient.instance.post("trucks/pdf", {
      trucks: this.trucks
    });
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  async loadingExport(vue) {
    let pallets = [];
    this.pallets.forEach(pallet => {
      if (pallet.status >= 1) {
        pallets.push(pallet);
      }
    });
    if (this.pallets.length != pallets.length) {
      alert(vue.$t('exports.warning'));
    }
    const pdf = await this.httpClient.instance.post("pallets/pdf/loading", {
      pallets: Helper.getIdsString(pallets)
    });
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  async barcodesExport(vue) {
    const pallets = this.pallets.filter(pallet => {
      return pallet.number != null;
    });
    if (pallets.length == 0) {
      alert(vue.$t('exports.no_pallets'));
      return;
    }
    if (this.pallets.length != pallets.length) {
      alert(vue.$t('exports.warning'))
    }
    const pdf = await this.httpClient.instance.post("pallets/barcodes", {
      pallets: Helper.getIdsString(pallets)
    });
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  static async productionExport(workCenterId) {
    const client = new Client();
    const pdf = await client.instance.post(`work-centers/${workCenterId}/export`);
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  static async productionPositionExport(workCenterId){
    const client = new Client();
    const pdf = await client.instance.post(`work-centers/${workCenterId}/position-export`);
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  static async customPdf(rows){
    const client = new Client();
    const pdf = await client.instance.post(`custom-pdf`,{
      rows: rows
    });
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  static async preperationCsv(orders){
    const client = new Client();
    const pdf = await client.instance.post('orders/preperation/csv', {
      orders: orders
    });
    console.log(pdf.data);
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  static async productTemplateExport(templateId, products){
    const client = new HttpClient();
    const pdf = await client.instance.post(`products/template/${templateId}`, {
      products: products
    });
    console.log(pdf.data);
    await Helper.timeout(50);
    window.open(pdf.data, "_blank");
  }

  download(filename, text) {
    var element = document.createElement("a");
    element.setAttribute(
      "href",
      "data:text/plain;charset=utf-8," + encodeURIComponent(text)
    );
    element.setAttribute("download", filename);
    element.style.display = "none";
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  }
}
